module.exports = __webpack_public_path__ + "img/front length from HPS to waist.c83f52dd.png";